import axios from "axios";
import { baseUrl } from "./constants/constants";


const instance=axios.create({

baseUrl:baseUrl,
axios:axios
})

export default instance;